/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeactivateElectronMapperItem
 */
export interface DeactivateElectronMapperItem {
    /**
     * 
     * @type {string}
     * @memberof DeactivateElectronMapperItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeactivateElectronMapperItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeactivateElectronMapperItem
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DeactivateElectronMapperItem
     */
    gameId?: string;
}

/**
 * Check if a given object implements the DeactivateElectronMapperItem interface.
 */
export function instanceOfDeactivateElectronMapperItem(value: object): value is DeactivateElectronMapperItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function DeactivateElectronMapperItemFromJSON(json: any): DeactivateElectronMapperItem {
    return DeactivateElectronMapperItemFromJSONTyped(json, false);
}

export function DeactivateElectronMapperItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateElectronMapperItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'source': json['source'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function DeactivateElectronMapperItemToJSON(json: any): DeactivateElectronMapperItem {
    return DeactivateElectronMapperItemToJSONTyped(json, false);
}

export function DeactivateElectronMapperItemToJSONTyped(value?: DeactivateElectronMapperItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': value['source'],
        'gameId': value['gameId'],
    };
}

